//Components
import WhatsappButton from "../../components/WhatsappButton/WhatsappButton";
import ContactNavbar from "../../components/ContactNavbar/ContactNavbar";
import Navbar from "../../components/Navbar/Navbar";
import BodyZapSignThankScreen from "../../components/BodyZapSignThankScreen/BodyZapSignThankScreen";

const ZapSignThankScreen = ({ navbarData }) => {
  return (
    <>
      <WhatsappButton />
      <ContactNavbar social={navbarData.data} />
      <Navbar />
      <BodyZapSignThankScreen />
    </>
  );
};

export default ZapSignThankScreen;
